import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const initialState = {
  authPermission: [],
};
const authPermissionSlice = createSlice({
  name: "authPermission",

  initialState,
  reducers: {
    setAuthPermission: (state: any, action: PayloadAction<any>) => {
      const payload = action.payload;
      state.authPermission = payload;
    },
    removeAuthPermission: (state: any) => {
      state.authPermission = [];
    },
  },
});

export const { setAuthPermission, removeAuthPermission } = authPermissionSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default authPermissionSlice.reducer;
